<template>
  <div class="modal" :id="id" tabindex="-1" role="dialog" aria-labelledby="loadMeLabel" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body text-center">
        <div class="loader"><i class="fa fa-spinner  fa-pulse fa-3x fa-fw" aria-hidden="true"></i></div>
        <div clas="loader-txt">
          <p>{{loadingText}}<br><br><small>{{loadingSubText}}</small></p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
      id: {
      type: String,
      default: 'loadMe'
    },
    loadingText: {
      type: String,
      default: 'Loading ..... '
    },
    loadingSubText: {
      type: String,
      default: ''
    },
  },
  
}
</script>
<style scoped>
.modal-content {
  border-radius: 0px;
  box-shadow: 0 0 20px 8px rgba(0, 0, 0, 0.7);
}

.modal-backdrop.show {
  opacity: 0.75;
}


 .loader-txt p {
    font-size: 13px;
    color: #666;
   
  }
 .loader-txt small {
      font-size: 11.5px;
      color: #999;
    }
</style>


// WEBPACK FOOTER //
// VALoading.vue?25de9e0e